import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { Box } from '@wds/box';
import { Button } from '@wds/button';
import { Typography } from '@wds/typography';

import { Logo } from '@sm/webassets';

const DeveloperWebNavHeaderDesktop = ({ navItems, domain, subdomain, url }) => {
  return (
    <div className="sm-dev-web-nav-header">
      <Box display="flex">
        <a href="/" className="sm-dev-web-nav-header__logo">
          <Logo color="alt" />
        </a>
        <a href="/" className="sm-dev-web-nav-header__mainlink">
          <Typography variant="sectionTitle" color="light">
            <strong className="sm-dev-web-nav-header__pagetitle">Developer</strong>
          </Typography>
        </a>
        <Box>
          <nav className="sm-dev-web-nav-header__nav">
            <ul>
              {navItems.map(nav => (
                <li key={nav.target}>
                  <a href={`${nav.target}`} className={nav.class}>
                    {nav.text}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </Box>
        <Box flexItemGrow display="flex" flexJustify="flex-end">
          <Box mt={2}>
            <Button
              color="alt"
              href={
                domain
                  ? `https://${subdomain}.${domain}.com/user/sign-in?ep=${encodeURIComponent(url)}`
                  : '/user/sign-in'
              }
              size="sm"
            >
              Sign in
            </Button>
          </Box>
          <Box mt={2} ml={1}>
            <Button
              color="alt"
              href={
                domain
                  ? `https://${subdomain}.${domain}.com/user/sign-up?ep=${encodeURIComponent(url)}`
                  : '/user/sign-up'
              }
              size="sm"
            >
              Sign up
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

DeveloperWebNavHeaderDesktop.propTypes = {
  navItems: PropTypes.arrayOf(
    PropTypes.shape({
      target: PropTypes.string.isRequired,
      text: PropTypes.node.isRequired,
      class: PropTypes.string,
    })
  ).isRequired,
  domain: PropTypes.string.isRequired,
  subdomain: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default withRouter(DeveloperWebNavHeaderDesktop);
